// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__VxNuQ","title":"BackImages_title__2OKnK","images":"BackImages_images__3khvI"};